import { render, staticRenderFns } from "./bullsBelow18Months.vue?vue&type=template&id=6a205f20&scoped=true&"
import script from "./bullsBelow18Months.vue?vue&type=script&lang=js&"
export * from "./bullsBelow18Months.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a205f20",
  null
  
)

export default component.exports